var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPassWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_pass_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.64,20.42l-.13-.11V15a4.31,4.31,0,0,0-4.14-4.47H21.63A4.31,4.31,0,0,0,17.49,15v5.34l-.13.11A8,8,0,0,0,15,26.08a7.63,7.63,0,0,0,7.5,7.76A7.63,7.63,0,0,0,30,26.08,8,8,0,0,0,27.64,20.42ZM25.49,19l-.38-.17a7.51,7.51,0,0,0-2.1-.46l-.51,0-.46,0a7.48,7.48,0,0,0-2.15.46l-.36.16-.11,0a6,6,0,0,0-.62.33l-.6.34V15a3.6,3.6,0,0,1,3.43-3.75h1.74A3.6,3.6,0,0,1,26.8,15v4.7l-.6-.34c-.19-.12-.59-.32-.59-.32Zm-3,14.16a6.92,6.92,0,0,1-6.78-7.05A7.09,7.09,0,0,1,19.17,20l.4-.22a6.89,6.89,0,0,1,2.32-.67l.29,0h.6l.31,0a6.91,6.91,0,0,1,2.29.64l.45.25a7.09,7.09,0,0,1,3.45,6.13A6.92,6.92,0,0,1,22.5,33.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.75,26.2a1.83,1.83,0,1,0-2.5,0l.16.14L20.84,29c0,.5.45.83,1.08.83h1.16c.63,0,1.09-.33,1.09-.75l-.58-2.7Zm-2.21,2.87.67-3-.07-.1a.3.3,0,0,0-.16-.17,1.13,1.13,0,1,1,1,0,.31.31,0,0,0-.15.17l-.07.1.67,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 45,
    height: 45
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassWhite);
export default __webpack_public_path__ + "static/media/icon_pass_white.f85374ca795f125348ab97355234afe3.svg";
export { ForwardRef as ReactComponent };